<template>
  <div class="pm300 dfgdfyuyre">
    <img src="../assets/img/bhjhhse.png" class="w100 dfgyuxeru" />
    <div class="pd sdfdgdfteeryert">
      <div class="bgff yj4 pt20 pr">
        <p class="cen">
          <span class="fz16 z3 pr f_b jjnndsrtywe">团队注册</span>
        </p>
        <p class="cen zts fz16 mt10" v-if="statusId>1">
            <span>{{statusName}}</span>
            <span v-if="memo">，{{memo}}</span>
            <span v-if="statusId>1 && statusId==3">，修改信息后可以重复提交</span>
        </p>
        <div class="cen zts mt10 pr note " v-else>
          <p class="fz12 pt5 pl5 pr5 pm5">
            <span >旅行社、文化团体、学校、教育机构、行政机关及文化事业单位可申请团队账户信息注册，其它暂不受理</span>
          </p>
        </div>
        <div>
          <p class="mt20 fz16 pd">注册信息</p>

          <van-cell-group class="mt10">
            <van-field
              placeholder="4-16个字符，支持字母、数字及符号(不包含特殊字符)"
              clearable
              v-model="userName"
              :rules="[{ required: true }]"
            >
              <template slot="label">
                <i class="f_i jjnnjxer cz"></i>
                <span class="ml10 cz">用户名</span>
              </template>
            </van-field>
            <van-field
              placeholder="6-12个字符，支持字母、数字及符号(不包含特殊字符)"
              clearable
              type="password"
              v-model="password"
              :rules="[{ required: true }]"
            >
              <template slot="label">
                <i class="f_i jjnnjxer cz ab"></i>
                <span class="ml10 cz">密 码</span>
              </template>
            </van-field>
            <van-field
              placeholder="请输入确认密码"
              clearable
              type="password"
              v-model="confirmPassword"
              :rules="[{ required: true }]"
            >
              <template slot="label">
                <i class="f_i jjnnjxer cz ab"></i>
                <span class="ml10 cz">确认密码</span>
              </template>
            </van-field>
          </van-cell-group>
          <p class="mt15 fz16 pd">机构信息</p>

          <van-cell-group class="mt10">
            <!-- <van-field
              placeholder="请选择机构类型"
              readonly
              clearable
              is-link
              v-model="group.customerTypeName"
              :rules="[{ required: true }]"
              @click="showCustomerType = true"
            >
              <template slot="label">
                <i class="f_i jjnnjxer cz ac"></i>
                <span class="ml10 cz">机构类型</span>
              </template>
            </van-field> -->
            <van-field
              placeholder="请输入机构名称"
              clearable
              v-model="group.name"
              :rules="[{ required: true }]"
            >
              <template slot="label">
                <i class="f_i jjnnjxer cz ad"></i>
                <span class="ml10 cz">机构名称</span>
              </template>
            </van-field>
            <van-field
              placeholder="请输入机构代码"
              clearable
              v-model="group.code"
              :rules="[{ required: true }]"
            >
              <template slot="label">
                <i class="f_i jjnnjxer cz ae"></i>
                <span class="ml10 cz">机构代码</span>
              </template>
            </van-field>
            <!-- <van-field>
                            <template slot="label">
                                <i class="f_i jjnnjxer cz ae"></i>
                                <span class="ml10 cz">机构照片</span>
                            </template>
                            <template #input>
                                <van-uploader v-model="form.jnjjhsdh" :max-count="1" />
                            </template>                            
                        </van-field> -->
            <van-cell icon="star-o" title-style="min-width:150px" center >
              <template slot="title">
                 <!-- title="法人证照或证明" -->
                 <div class="cz">法人证照或证明</div>
                 <div class="cz fz10">(营业执照/组织机构代码/参观函等)</div>
              </template>
              <van-uploader :after-read="onRead" class="pd">                
                <van-icon name="photograph" size="20"/>                
              </van-uploader>
              <van-button
                v-if="group.photo"
                size="mini"
                @click="preview"
                class="group-regist-preview"
                >预览</van-button>                     
            </van-cell>
            <!-- <van-cell icon="star-o" title-style="min-width:120px" center >
              <template slot="title">
                 <div class="cz">介绍信或参观函</div>
              </template>
              <van-uploader v-model="fileList" preview-size="60" multiple max-count="1" :before-read="beforeRead" :after-read="afterRead">          
              </van-uploader>
            </van-cell> -->
            <van-cell title="注册所在地" class="field-cell">
              <van-row class="inline-cell">
                <van-col :span="showArea ? 12 : 24">
                  <picker-field
                    placeholder="请选择注册所在地"
                    v-model="regionId"
                    :list="regions"
                    :is-link="!showArea"
                  />
                </van-col>
                <van-col span="12" v-if="showArea">
                  <picker-field placeholder="请选择注册所在地" v-model="areaId" :list="areas" />
                </van-col>
              </van-row>
            </van-cell>
          </van-cell-group>
          <p class="mt15 fz16 pd">联系人信息</p>
          <van-cell-group class="mt10">
            <van-field
              placeholder="请输入姓名"
              clearable
              v-model="contactName"
              :rules="[{ required: true }]"
            >
              <template slot="label">
                <i class="f_i jjnnjxer cz af"></i>
                <span class="ml10 cz">姓 名</span>
              </template>
            </van-field>
            <van-field
              placeholder="请输入手机号"
              clearable
              maxlength="11"
              v-model="contactMobile"
              :rules="[{ required: true }]"
            >
              <template slot="label">
                <i class="f_i jjnnjxer cz ag"></i>
                <span class="ml10 cz">手机号</span>
              </template>
            </van-field>
            <!-- <van-field
              placeholder="请输入二代身份证号码"
              readonly
              class="certNo"
              clearable
              :rules="[{ required: true }]"
              :value="contactCertNo"
               @touchstart.native.stop="onShowNumberKeyboard"
            >
              <template slot="label">
                <i class="f_i jjnnjxer cz ae"></i>
                <span class="ml10 cz">身份证</span>
              </template>
            </van-field>  -->
            
            <van-cell
              class="certNo"
              :value="contactCertNo || '请输入二代身份证号码'"
              plain
              type="primary"
              @touchstart.native.stop="onShowNumberKeyboard"
              :value-class="contactCertNo ? 'z4' : ''"
            >   
              <template slot="title">
                <i class="f_i jjnnjxer cz ae"></i>
                <span class="custom-title">身份证</span>
              </template>
            </van-cell>        
            
          </van-cell-group>
          <!-- <div class="dsfsdtywwer">
            <van-button
              type="primary"
              class="w100"
              :loading="loading"
              @click="onClick"
            >
              提交
            </van-button>
          </div> -->
          
            <bottom-button
              text="提交"
              :loading="loading"
              @click="onClick"
            ></bottom-button> 
        </div>
      </div>
    </div>
    <van-number-keyboard
      safe-area-inset-bottom
      theme="custom"
      class=""
      :title="
        contactCertNo
          ? '身份证：' + contactCertNo
          : '请输入' +
            (group.contactName ? group.contactName + '的' : '') +
            '身份证号码'
      "
      v-model="contactCertNo"
      :show="showNumberKeyboard"
      :maxlength="18"
      extra-key="X"
      close-button-text="完成"
      @blur="onBlurContactNumberKeyboard()"
    />
    <!-- <van-action-sheet
      v-model="showCustomerType"
      :actions="customerTypes[0].children"
      @select="onSelect"
    /> -->
    <van-dialog v-model="showRegistNotice" width="calc(100vw - 40px)" :showConfirmButton="false"  >
      <div class="cen pm10 mt10 notice-title">团队注册须知</div>
      <div class="notice-cross"><van-icon name="cross" @click="onCancel" /></div>
          <div class="regist-notice fz12 pd z3 mt10 mb10"
              v-html="notice.registNotice"
            ></div>
        <div class="pd pt10 pm10 fz14 notice-checkbox" >
          <van-checkbox
            v-model="checked"
            icon-size="16px"
            checked-color="#845F56"
          >
            我已认真阅读团队注册须知并同意
          </van-checkbox>
        </div>
        <van-button type="primary" block  @click="onConfirm" :class="(!checked)?'sdrtter':''" >确 认</van-button>
        
    </van-dialog>
    <van-image-preview v-model="showImagePreview" :showIndex="false" :images="[group.photo]" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import appConsts from "@/store/consts.js";
import BottomButton from "@/components/BottomButton.vue";
import IdcardField from "@/components/IdCardField.vue";
import PickerField from "@/components/PickerField.vue";
import imageHelper from "@/utils/imageHelper.js";
import validate from "@/utils/validator.js";
import customerService from "@/services/customerService.js";
import commonService from "@/services/commonService.js";
import { aesEncrypt, aesDecrypt } from '@/utils/crypto';

export default {
  components: {
    BottomButton,
    IdcardField,
    PickerField,
  },
  props: {
    customerId: String,
  },
  data() {
    return {
      checked:false,
      showRegistNotice: true,
      showNumberKeyboard: false,
      loading: false,
      //showCustomerType: false,
      group: {
        // customerTypeId: "",
        userName: "",
        password:"",
        confirmPassword:"",
        name:"",
        code:"",
        photo: "",
        contactName:"",
        contactMobile:"",
        contactCertNo:"",
        areaId: "",
        photoChanged: false,
      },
      userName: "",
      password:"",
      confirmPassword:"",
      contactName:"",
      contactMobile:"",
      contactCertNo:"",
      // customerTypes: [{ text: "客户类型", children: [] }],
      statusId: 0,
      memo: "",
      realNameFlag: false,

      keYuanTypes: [],
      areaItems: [],
      regions: [],
      regionId: "",
      areas: [],
      areaId: "",
      fileList: [],
      showImagePreview: false
    };
  },
  computed: {
    statusName() {
      if (this.statusId == 2) {
        return "审核中";
      }
      if (this.statusId == 3) {
        return "审核未通过";
      }
      return "";
    },
    showArea() {
      return this.areas.length > 0 && this.areas[0].children.length > 0;
    },    
    ...mapState({
      notice: (state) => state.homeModule.notice,
    }),
  },
  methods: {
    onCancel(){
      this.$router.go(-1);
    },
    onConfirm(){
      this.showRegistNotice=false;
    },
    setRegions(keYuanTypeId) {
      this.regions = this.areaItems.filter((a) => a.value == keYuanTypeId);
    },
    onShowNumberKeyboard() { 
      this.showNumberKeyboard = true;
      document.activeElement.blur();
      // let top = 0;
      // let element = document.querySelectorAll(".certNo")[0];
      // while (element) {
      //   top += element.offsetTop;
      //   element = element.offsetParent;
      // }
      // window.scrollTo(0, top - 100);
    },
    onBlurContactNumberKeyboard() {
      try{
      let certRules = [
        {
          rule: "required",
        },
      ];
      certRules.push({
                rule: "isIdCard",
              });
      let result = validate([
        {
          value: this.contactCertNo,
          name: this.contactName +"证件号码",
          rules: certRules,
        },
      ]);
      // Vue.set(this.contactCertNo, "error", !result.success);
      // Vue.set(
      //   this.contactCertNo,
      //   "errorMessage",
      //   result.message
      // );
      if (!result.success) {
        this.$toast(result.message);
      }
      }
      finally{          
      this.showNumberKeyboard = false;
      }
    },
    // onSelect(e) {
    //   this.group.customerTypeId = e.value;
    //   this.group.customerTypeName = e.name;
    //   this.realNameFlag = e.realNameFlag;
    //   this.showCustomerType = false;
    // },
    async onRead(file) {
      try {
        let img = await imageHelper.resize(file.content, 700, 700);
        this.group.photo = img.photo;
        this.group.photoChanged = true;
      } catch (error) {
        this.group.photo = "";
      }
    },
    beforeRead(file){
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$toast('请上传 jpg/jpeg/png 格式图片');
        return false;
      }
      return true;
    },
    async afterRead() {  
      //console.log(JSON.stringify(this.fileList));
    },
    async onClick() {
      try {
        this.loading = true;
        await this.regist();
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    onSubPopupChange(show, height) {
      height -= 50;
      if (show) {
        this.$refs.grbody.style.height =
          this.$refs.grbody.clientHeight + height + "px";
        window.scrollTo(0, window.scrollY + height);
      } else {
        window.scrollTo(0, window.scrollY - height);
        this.$refs.grbody.style.height =
          this.$refs.grbody.clientHeight - height + "px";
      }
    },
    async regist() {
      this.group.areaId=this.areaId;
      if (!this.group.areaId && this.regionId) {
        this.group.areaId = this.regionId;
        this.group.areaTypeId=1;
      }
      // if(this.fileList.length>0)
      // {
      //   for(var i=0;i<this.fileList.length;i++)
      //   {
      //       this.group.visitLetterPhotoArray.push(this.fileList[i].content);
      //   }
      // }
      let validateRules = [
        {
          value: this.userName,
          name: "用户名",
          rules: [
            { rule: "required" },
            { rule: "minLength:4" },
            { rule: "maxLength:16" },
          ],
        },
        {
          value: this.password,
          name: "密码",
          rules: [
            { rule: "required" },
            { rule: "minLength:6" },
            { rule: "maxLength:12" },
          ],
        },
        // {
        //   value: this.group.customerTypeId,
        //   name: "机构类型",
        //   rules: [{ rule: "required" }],
        // },
        {
          value: this.group.name,
          name: "机构名称",
          rules: [{ rule: "required" }],
        },
        {
          value: this.group.code,
          name: "机构代码",
          rules: [{ rule: "required" }],
        },
        {
          value: this.group.photo,
          name: "机构照片",
          rules: [{ rule: "required" }],
        },
        {
          value: this.group.areaId,
          name: "注册所在地",
          rules: [{ rule: "required" }],
        },
        {
          value: this.contactName,
          name: "姓名",
          rules: [{ rule: "required" }],
        },
        {
          value: this.contactMobile,
          name: "手机号码",
          rules: [{ rule: "required" }, { rule: "isMobile" }],
        },
        {
          value: this.contactCertNo,
          name: "身份证",
          rules: [{ rule: "required" }, { rule: "isIdCard" }],
        },
      ];
      let result = validate(validateRules);
      if (!result.success) {
        this.$toast(result.message);
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.$toast("两次输入的密码不一致");
        return;
      }
      const uidPattern = /^[a-zA-Z0-9_-]{4,16}$/;
      if (!uidPattern.test(this.userName)) {
        this.$toast("用户名格式不正确");
        return;
      }
      const pwdPattern = /^[a-zA-Z0-9_-]{6,12}$/;
      if (!pwdPattern.test(this.password)) {
        this.$toast("密码格式不正确");
        return;
      }
      //加密      
      this.group.userName =  aesEncrypt(this.userName);
      this.group.password =  aesEncrypt(this.password);
      this.group.confirmPassword =  aesEncrypt(this.confirmPassword);
      this.group.contactName =  aesEncrypt(this.contactName);
      this.group.contactMobile =  aesEncrypt(this.contactMobile);
      this.group.contactCertNo =  aesEncrypt(this.contactCertNo);

      await customerService.registAsync(this.group);
      this.$router.push("/groupregistsuccess");
    },
    preview() {
      if (this.group.photo) {
        this.showImagePreview = true;
      }
    },
    ...mapActions("homeModule", [appConsts.loadOrderNoticeAsync]),
  },
  async created() {
    // let customerTypes = await customerService.getCustomerTypeComboboxItemsAsync();
    // this.customerTypes = [
    //   {
    //     text: "客户类型",
    //     children: customerTypes.map((c) => {
    //       return {
    //         name: c.displayText,
    //         value: c.value,
    //         realNameFlag: c.disabled
    //       };
    //     }),
    //   },
    // ];
    
    const getTouristOriginTree = commonService.getTouristOriginTreeAsync().then((treeNode) => {
      let keYuanTypeItems = treeNode.nodes.map((item) => {
        return {
          value: item.value,
          text: item.displayText,
          disabled: item.disabled,
        };
      });
      this.keYuanTypes = [
        {
          text: "客源类型",
          children: keYuanTypeItems,
        },
      ];

      this.areaItems = treeNode.nodes.map((keYuan) => {
        return {
          value: keYuan.value,
          children: keYuan.nodes.map((region) => {
            return {
              text: region.displayText,
              value: region.value,
              disabled: region.disabled,
              children: region.nodes.map((area) => {
                return {
                  text: area.displayText,
                  value: area.value,
                  disabled: area.disabled,
                };
              }),
            };
          }),
        };
      });
      
      this.setRegions(1);
    });

    
    if (this.customerId) {
      const getForEdit = customerService.getForEditAsync(this.customerId).then((customer)=>{

        this.group.customerid = this.customerId; 
        //this.group.customerTypeId = customer.customerTypeId;
        // if(customer.customerTypeId && customer.customerTypeId>0)
        // {
        //     this.group.customerTypeName = this.customerTypes[0].children.find(
        //       (o) => o.value == customer.customerTypeId
        //     ).name;
        // }
        this.group.name = customer.name;
        this.group.code = customer.businessLicense;
        this.group.photo = customer.photo;

        this.group.userName = aesDecrypt(customer.uid);
        this.group.password = "";
        this.group.confirmPassword = "";
        this.contactName = aesDecrypt(customer.linkman);
        this.contactMobile = aesDecrypt(customer.mobile);
        this.contactCertNo = aesDecrypt(customer.certNo);

        this.group.areaId = customer.registAreaId; 
        this.regionId = customer.registAreaTypeId; 
        this.statusId = customer.statusId;
        this.memo = customer.memo;  
      });
     
      Promise.all([getTouristOriginTree, getForEdit])
      .then(() => {

          if(this.group.areaId)
          {
            this.regions[0].children.forEach(child => {                
                child.children.forEach(area => {
                  if(area.value==this.group.areaId)
                  { 
                      this.regionId = child.value;
                  }
                });
            });
            
          }
      })
      .catch(() => {

      }).finally(()=>{
        if(this.group.areaId)
        {
            this.areaId = this.group.areaId;
        }
      });
    }    
  },
  watch: {
    regionId: function (val) {
      try {
        this.loading = true;
        this.areaId = "";
        if (val == "") {
          this.areas = [
            {
              text: "",
              children: [],
            },
          ];
        } else {
          this.areas = this.regions[0].children.filter((r) => r.value == val);
        }
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style lang="scss">
.dfgyuxeru {
  position: relative;
}

.sdfdgdfteeryert {
  margin-top: -40px;
}

.custom-title{
  margin-left: 10px
}
.van-cell__left-icon {
    margin-right: 12px;
}
.van-field{
    border-bottom: 0px solid #ebedf0;
}
.note{
  background: #f3e8e7;
  border-radius: 4px;
}
.regist-notice {
  overflow: auto;
  max-height: calc(100vh - 320px);
  line-height: 18px;
}
.van-dialog__confirm{
      color: #a9716d
}
.notice-title{
    border-bottom: 1px;
    border-bottom-color: #00000017;
    border-bottom-style: solid;
}
.notice-checkbox{
    border-top: 1px;
    border-top-color: #00000017;
    border-top-style: solid;
}
.notice-cross{
    position: absolute;
    top: 13px;
    right: 10px;
}
</style>
